import { DiscountProfileEndpoints } from '@/modules/seller-management/discount-profile/api/discountProfileEndpoints'

/**
 * Discount Profile endpoint instance
 * instantiate Discount Profile api class with different api path
 */

export const discountProfileEndpoints = new DiscountProfileEndpoints()
